import { IfcGroup } from "./index.js";
import { IfcInventoryTypeEnumDeserializeStep } from "./index.js";
import { IfcOrganization } from "./index.js";
import { IfcPerson } from "./index.js";
import { IfcPersonAndOrganization } from "./index.js";
import { IfcCostValue } from "./index.js";
import { stepExtractOptional, stepExtractArrayToken, stepExtractArrayBegin, skipValue, } from "../../step/parsing/step_deserialization_functions.js";
/* This is generated code, don't modify */
import EntityTypesIfc from "./entity_types_ifc.gen.js";
///**
// * http://www.buildingsmart-tech.org/ifc/ifc4/final/html/link/ifcinventory.htm */
export class IfcInventory extends IfcGroup {
    get type() {
        return EntityTypesIfc.IFCINVENTORY;
    }
    get PredefinedType() {
        if (this.PredefinedType_ === void 0) {
            this.PredefinedType_ = this.extractLambda(5, IfcInventoryTypeEnumDeserializeStep, true);
        }
        return this.PredefinedType_;
    }
    get Jurisdiction() {
        if (this.Jurisdiction_ === void 0) {
            const value = this.extractReference(6, true);
            if (!(value instanceof IfcOrganization) && !(value instanceof IfcPerson) && !(value instanceof IfcPersonAndOrganization) && value !== null) {
                throw new Error("Value in STEP was incorrectly typed for field");
            }
            this.Jurisdiction_ = value;
        }
        return this.Jurisdiction_;
    }
    get ResponsiblePersons() {
        if (this.ResponsiblePersons_ === void 0) {
            let cursor = this.getOffsetCursor(7);
            const buffer = this.buffer;
            const endCursor = buffer.length;
            if (stepExtractOptional(buffer, cursor, endCursor) === null) {
                return null;
            }
            const value = [];
            let signedCursor0 = stepExtractArrayBegin(buffer, cursor, endCursor);
            cursor = Math.abs(signedCursor0);
            while (signedCursor0 >= 0) {
                const value1 = this.extractBufferElement(buffer, cursor, endCursor, IfcPerson);
                if (value1 === void 0) {
                    throw new Error("Value in STEP was incorrectly typed");
                }
                cursor = skipValue(buffer, cursor, endCursor);
                value.push(value1);
                signedCursor0 = stepExtractArrayToken(buffer, cursor, endCursor);
                cursor = Math.abs(signedCursor0);
            }
            this.ResponsiblePersons_ = value;
        }
        return this.ResponsiblePersons_;
    }
    get LastUpdateDate() {
        if (this.LastUpdateDate_ === void 0) {
            this.LastUpdateDate_ = this.extractString(8, true);
        }
        return this.LastUpdateDate_;
    }
    get CurrentValue() {
        if (this.CurrentValue_ === void 0) {
            this.CurrentValue_ = this.extractElement(9, true, IfcCostValue);
        }
        return this.CurrentValue_;
    }
    get OriginalValue() {
        if (this.OriginalValue_ === void 0) {
            this.OriginalValue_ = this.extractElement(10, true, IfcCostValue);
        }
        return this.OriginalValue_;
    }
    constructor(localID, internalReference, model) {
        super(localID, internalReference, model);
    }
}
IfcInventory.query = [EntityTypesIfc.IFCINVENTORY];
IfcInventory.expectedType = EntityTypesIfc.IFCINVENTORY;
